import { useState } from "react";
import benepayData from "../benepay-data.json";
import TryItOut from "components/getAuthToken";

//Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faCopy } from "@fortawesome/free-solid-svg-icons";

//Utils
import { copyToClipboard } from "utils/commonUtility";

export default function Authentication() {
    const authUrl = process.env.REACT_APP_UAT_AUTH_URL;
    const [copied, setCopied] = useState(false);
    const [responseCopied, setResponseCopied] = useState(false);

    const handleCopy = () => {
        const codeElement = document.getElementById("sampleRequestCode");
        const text = codeElement.innerText || codeElement.textContent;

        copyToClipboard(text, setCopied);
    }

    const handleResponseCopy = () => {
        const text = `{ "access_token": "Token", "expires_in": 300, "token_type": "Bearer" }`;

        copyToClipboard(text, setResponseCopied);
    }

    return (
        <>
            <div class="grid grid-cols-12 gap-1" id="Introduction">
                <div class="col-span-12 md:col-span-8 gap-1">
                    <div>
                        <p className="font-bold text-[32px]">Authentication</p>
                    </div>

                    <div>
                        <hr className="border-t border-gray-300 my-2 w-full" />
                    </div>

                    <div>
                        <div className="col-span-12 md:col-span-8 gap-1">
                            <div>
                                <p className="text-gray-700 mb-4">
                                    BeneCollect uses OAuth 2.0 Client Credentials flow for secure API authentication. This authentication method ensures secure access to BeneCollect's APIs while maintaining robust security standards.
                                </p>

                                <div className="space-y-4 mt-6" id="AuthenticationProcess">
                                    <div className="p-4 bg-gray-50 border-l-4 border-blue-500 rounded">
                                        <h3 className="font-semibold text-gray-800">Authentication Process</h3>
                                        <p className="text-gray-600 mt-2">
                                            To access BeneCollect APIs, you'll need to:
                                        </p>
                                        <ol className="list-decimal ml-5 mt-2 text-gray-600 space-y-2">
                                            <li>Obtain API credentials (Client ID and Client Secret) after on-boarding with BenePay</li>
                                            <li>Generate an access token using these credentials</li>
                                            <li>Include the token in subsequent API requests</li>
                                        </ol>
                                    </div>

                                    <div className="p-4 bg-gray-50 border-l-4 border-green-500 rounded" id="KeyFeatures">
                                        <h3 className="font-semibold text-gray-800">Key Features</h3>
                                        <ul className="list-disc ml-5 mt-2 text-gray-600 space-y-2">
                                            <li>OAuth 2.0 standard compliance</li>
                                            <li>Secure token-based authentication</li>
                                            <li>Time-limited access tokens (5 minutes validity)</li>
                                            <li>Automatic token refresh capability</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mt-9" id="Environment">
                            <div>
                                <p className="text-gray-800 font-bold text-xl">Environment</p>
                            </div>

                            <table className="w-full border border-gray-200 text-left mt-3">
                                <tbody>
                                    <tr className="border">
                                        <td className="p-3 font-semibold text-gray-600 border w-64">Test Environment</td>
                                        <td className="p-3 border">
                                            <a href={benepayData.authinfo.UATurl} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">{benepayData.authinfo.UATurl}</a>
                                        </td>
                                    </tr>
                                    {/* <tr className="border bg-gray-100">
                                        <td className="p-3 font-semibold text-gray-600 border">Production Environment</td>
                                        <td className="p-3 border">
                                            <a href={benepayData.authinfo.PRODurl} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">{benepayData.authinfo.PRODurl}</a>
                                        </td>
                                    </tr> */}
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-9">
                            <div>
                                <p className="text-gray-800 font-bold text-xl">Request Header</p>
                            </div>

                            <table className="w-full border border-gray-200 text-left mt-3">
                                <tbody>
                                    <tr className="border">
                                        <td className="p-3 font-semibold text-gray-600 border w-64">Content-Type</td>
                                        <td className="p-3 border">
                                            application/x-www-form-urlencoded
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-9">
                            <div>
                                <p className="text-gray-800 font-bold text-xl">Credentials</p>
                            </div>

                            <table className="min-w-full border border-gray-200 text-left mt-3">
                                <tbody>
                                    <tr className="bg-white border border-gray-200">
                                        <td className="p-3 font-semibold border border-gray-200 w-64">App Client Id</td>
                                        <td className="p-3 border border-gray-200">***********ykuhbkgvou</td>
                                    </tr>
                                    <tr className="bg-gray-100 border border-gray-200">
                                        <td className="p-3 font-semibold border border-gray-200">App Client Secret</td>
                                        <td className="p-3 border border-gray-200">**********hjbskhabkuyauk</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="p-4 mt-8 bg-gray-50 border-l-4 border-blue-500 rounded" id="SampleRequest">
                        <div className="flex justify-between items-center">
                            <h3 className="font-semibold text-gray-800">Sample Request</h3>
                            <button
                                onClick={handleCopy}
                                className="text-gray-700 px-2 py-1 rounded text-sm"
                            >
                                {!copied && <p className="font-bold text-lg"><FontAwesomeIcon className="" icon={faCopy} /></p>}
                                {copied && <span className="text-md ml-1 text-green-600 font-bold">Copied!</span>}
                            </button>
                        </div>

                        <div className="mt-4 overflow-x-auto bg-gray-900 text-white rounded-lg p-3">
                            <pre className="whitespace-pre-wrap text-sm w-max">
                                <code id="sampleRequestCode">
                                    <span className="text-yellow-500">curl</span> <span className="text-green-400">--location</span>{' '}
                                    <span className="text-blue-400">'https://bene-collect.auth.eu-west-2.amazoncognito.com/oauth2/token'</span> \ <br />
                                    <span className="text-green-400">--header</span>{' '}
                                    <span className="text-blue-400">'Content-Type: application/x-www-form-urlencoded'</span> \<br />
                                    <span className="text-green-400">--header</span>{' '}
                                    <span className="text-blue-400">'Cookie: XSRF-TOKEN=bd4d51ed-8b16-4c39-99f2-0b7e15bcb92a'</span> \<br />
                                    <span className="text-green-400">--data-urlencode</span>{' '}
                                    <span className="text-blue-400">'grant_type=client_credentials'</span> \<br />
                                    <span className="text-green-400">--data-urlencode</span>{' '}
                                    <span className="text-blue-400">'client_id=*************51trpog3'</span> \<br />
                                    <span className="text-green-400">--data-urlencode</span>{' '}
                                    <span className="text-blue-400">'client_secret=*****************ldidef54s9udtnd3uses90r'</span> <br />
                                </code>
                            </pre>
                        </div>
                    </div>

                    <div class="p-4 mt-7 bg-gray-50 border-l-4 border-blue-500 rounded" id="SampleResponse">
                        <div className="flex justify-between items-center">
                            <h3 class="font-semibold text-gray-800">Sample Response</h3>
                            <button
                                onClick={handleResponseCopy}
                                className="text-gray-700 px-2 py-1 rounded text-sm"
                            >
                                {!responseCopied && <p className="font-bold text-lg"><FontAwesomeIcon className="" icon={faCopy} /></p>}
                                {responseCopied && <span className="text-md ml-1 text-green-600 font-bold">Copied!</span>}
                            </button>
                        </div>

                        <p class="text-gray-600 mt-3">{`{`}</p>
                        <p class="text-gray-600 mt-1 pl-5">{`"access_token": "Token",`}</p>
                        <p class="text-gray-600 mt-1 pl-5">{`"expires_in": 300,`}</p>
                        <p class="text-gray-600 mt-1 pl-5">{`"token_type": "Bearer",`}</p>
                        <p class="text-gray-600 mt-1">{`}`}</p>
                    </div>
                </div>

                <div class="hidden md:col-span-4 md:block">
                    <div className="sticky top-4 p-4">
                        <div className="mb-6">
                            <div class="bg-blue-400 text-white text-center p-2 rounded-lg shadow-lg max-w-2xl mx-auto">
                                <p class="text-2xl font-semibold justify-between flex items-center">
                                    <span className='ml-2'>Try It Yourself</span>
                                    <FontAwesomeIcon className='ml-2 mr-3' icon={faCode} />
                                </p>
                            </div>
                            <h3 className="text-lg font-semibold mb-4 mt-5">Get Access Token</h3>
                            <div className="space-y-4">
                                <TryItOut url={authUrl} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}